import { hasCapability, type User } from "../base";

export const buyerData = {
  read: (user: User) => hasCapability(user, "buyerData.read"),
};
